import { render } from "./LearningMenu.vue?vue&type=template&id=95d579f6"
const script = {}

import "./LearningMenu.vue?vue&type=style&index=0&id=95d579f6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__